import axios from "axios";
import { BASE_URL } from "./auth/types";

export const baseUrl = BASE_URL;

const api = axios.create({
  baseURL: baseUrl,
});

export default api;
